<div class="w-full min-h-screen relative bg-white">
  <!-- Breadcrumb -->
  <div class="w-full px-4 sm:px-6 lg:px-8 pt-1 sm:pt-2 md:pt-3">
    <app-breadcrum [data]="breadcrumbData"></app-breadcrum>
  </div>

  <!-- Desktop/Tablet Layout -->
  <div class="hidden md:flex w-full px-4 sm:px-6 lg:px-8 mt-4 gap-6">
    <!-- Sidebar -->
    <nav class="w-1/4 sticky top-20 h-[calc(100vh-6rem)] overflow-y-auto pr-4 shrink-0 text-sm">
      <ul class="space-y-3 text-gray-600 font-semibold">
        <li
          (click)="scrollToSection('intro')"
          [class.text-blue-600]="activeSection === 'intro'"
          class="cursor-pointer hover:text-blue-600"
        >
          Privacy Policy
        </li>
        <li
          (click)="scrollToSection('background')"
          [class.text-blue-600]="activeSection === 'background'"
          class="cursor-pointer hover:text-blue-600"
        >
          1. Background & Key Info
        </li>
        <li
          (click)="scrollToSection('collect')"
          [class.text-blue-600]="activeSection === 'collect'"
          class="cursor-pointer hover:text-blue-600"
        >
          2. Personal Data We Collect
        </li>
        <li
          (click)="scrollToSection('how-collect')"
          [class.text-blue-600]="activeSection === 'how-collect'"
          class="cursor-pointer hover:text-blue-600"
        >
          3. How We Collect Data
        </li>
        <li
          (click)="scrollToSection('how-use')"
          [class.text-blue-600]="activeSection === 'how-use'"
          class="cursor-pointer hover:text-blue-600"
        >
          4. How We Use Data
        </li>
        <li
          (click)="scrollToSection('third-party')"
          [class.text-blue-600]="activeSection === 'third-party'"
          class="cursor-pointer hover:text-blue-600"
        >
          5. Third-Party Services
        </li>
        <li
          (click)="scrollToSection('cookies')"
          [class.text-blue-600]="activeSection === 'cookies'"
          class="cursor-pointer hover:text-blue-600"
        >
          6. Cookies
        </li>
        <li
          (click)="scrollToSection('rights')"
          [class.text-blue-600]="activeSection === 'rights'"
          class="cursor-pointer hover:text-blue-600"
        >
          7. Your Rights
        </li>
        <li
          (click)="scrollToSection('transfers')"
          [class.text-blue-600]="activeSection === 'transfers'"
          class="cursor-pointer hover:text-blue-600"
        >
          8. Cross-Border Transfers
        </li>
        <li
          (click)="scrollToSection('security')"
          [class.text-blue-600]="activeSection === 'security'"
          class="cursor-pointer hover:text-blue-600"
        >
          9. Data Security
        </li>
        <li
          (click)="scrollToSection('retention')"
          [class.text-blue-600]="activeSection === 'retention'"
          class="cursor-pointer hover:text-blue-600"
        >
          10. Data Retention
        </li>
        <li
          (click)="scrollToSection('grievance')"
          [class.text-blue-600]="activeSection === 'grievance'"
          class="cursor-pointer hover:text-blue-600"
        >
          11. Grievance Officer
        </li>
      </ul>
    </nav>

    <!-- Main content -->
    <div class="w-3/4 min-w-0 px-2 sm:px-4 overflow-y-auto text-gray-800">
      <!-- Intro Section -->
      <section #introSection id="intro" class="scroll-mt-24 pt-5 pb-5">
        <h1 class="text-2xl font-bold mb-1 text-black">PRIVACY POLICY</h1>
        <p class="text-sm font-semibold text-gray-500 mb-4">Last updated: [__]</p>
        <p class="mb-3 text-sm leading-relaxed">
          At Tata Motors Limited (“Tata”, “us”, “our” and “we”), we are committed to protecting your personal data and respecting your privacy. This Privacy Policy (“Policy”) outlines our practices in relation to the collection, storage, usage, processing, and disclosure of personal data that you have consented to share with us when you access, use, or otherwise interact with our Platform or avail our Services.
        </p>
        <p class="text-sm leading-relaxed">
          Please note that unless specifically defined in this Policy, capitalised terms shall have the same meaning ascribed to them in our Terms of Use, available at [insert link] (“Terms”). Please read this Policy in consonance with the Terms.
        </p>
      </section>

      <!-- Section 1: Background and Key Information -->
      <section #backgroundSection id="background" class="scroll-mt-24 pt-5 pb-5 border-t border-gray-100">
        <h2 class="text-2xl font-bold mb-4 text-black">1. BACKGROUND AND KEY INFORMATION</h2>
        <div class="space-y-4 text-sm leading-relaxed">
          <div>
            <h3 class="font-semibold text-base mb-1 text-black">(a) How this Policy applies:</h3>
            <p>
              This Policy applies to individuals who access or use the Services (“you”). By accessing the Platform or using the Services, you confirm that you have read, accepted and consented to the terms of this Policy.
            </p>
          </div>
          <div>
            <h3 class="font-semibold text-base mb-1 text-black">(b) Review and Updates:</h3>
            <p>
              We regularly review and update this Policy, and we request you to regularly review this Policy. It is important that the personal data we hold about you is accurate and current. Please keep us informed if your personal data changes during your relationship with us.
            </p>
          </div>
        </div>
      </section>

      <!-- Section 2: Personal Data That We Collect -->
      <section #collectSection id="collect" class="scroll-mt-24 pt-5 pb-5 border-t border-gray-100">
        <h2 class="text-2xl font-bold mb-4 text-black">2. PERSONAL DATA THAT WE COLLECT</h2>
        <div class="space-y-4 text-sm leading-relaxed">
          <div>
            <p class="mb-2">
              <strong>(a)</strong> We collect different types of personal data about you, as may be applicable to you, depending on the utility our Services provide you with. This includes, but is not limited to:
            </p>
            <ul class="list-disc ml-6 space-y-2">
              <li>
                <strong>(i) Contact Data</strong>, such as your mailing address, email address, and mobile numbers.
              </li>
              <li>
                <strong>(ii) Identity and Profile Data</strong>, such as your name, username or other similar identifiers, photographs, gender, designation, and details relating to your business operations.
              </li>
              <li>
                <strong>(iii) Marketing and Communications Data</strong>, such as your office address, email address, information posted in service requests, offers, feedback, comments, pictures and discussions in our chat boxes, responses to surveys and polls, your preferences in receiving marketing communications from us and our third parties, and your communication preferences.
              </li>
              <li>
                <strong>(iv) Technical Data</strong>, which includes your IP address, browser type, internet service provider, details of operating system, device ID, device type, location data, and other technology on the devices that you use to access the Platform.
              </li>
              <li>
                <strong>(v) Transaction Data</strong>, which includes details of transactions that may occur through the Platform or in connection with the Services. For example, transaction data may include the Services you have sought or availed through the Platform or confirmations of such Services.
              </li>
              <li>
                <strong>(vi) Financial Data</strong>, which includes your past credit history, income details, details of loans issued or otherwise applied for through the Platform, payments, and repayments thereof, bank account details, and bank account statements.
              </li>
              <li>
                <strong>(vii) Usage Data</strong>, which includes information about how you use the Services, your activity on the Platform, booking history, frequency of engaging with the Platform, click rates, date and time stamps, page views, and user interests.
              </li>
            </ul>
          </div>
          <p>
            <strong>(b)</strong> We also collect, use, and share aggregated data, such as statistical or demographic data, for our business purposes. Aggregated data could be derived from your personal data, but is not considered personal data under the law as it does not directly or indirectly reveal your identity. However, if we combine or connect aggregated data with your personal data so that it can directly or indirectly identify you, we treat the combined data as personal data, which will be used in accordance with this Policy.
          </p>
          <p>
            <strong>(c)</strong> Where we need to collect personal data by law, or under the Terms, and you fail to provide that data when requested, we may not be able to perform our obligations set out in the Terms or under applicable laws. In this case, we may have to limit your access to the Platform or cancel the Services you avail from us.
          </p>
        </div>
      </section>

      <!-- Section 3: How We Collect Your Personal Data -->
      <section #howCollectSection id="how-collect" class="scroll-mt-24 pt-5 pb-5 border-t border-gray-100">
        <h2 class="text-2xl font-bold mb-4 text-black">3. HOW WE COLLECT YOUR PERSONAL DATA</h2>
        <div class="space-y-3 text-sm leading-relaxed">
          <p>We use different methods to collect personal data from and about you, including through:</p>
          <ul class="list-disc ml-6 space-y-2">
            <li>
              <strong>(a) Direct Interactions:</strong> We collect data directly from you if and when you provide it to us through the Platform or any interaction with Tata.
            </li>
            <li>
              <strong>(b) Automated Technologies or Interactions:</strong> Each time you visit the Platform or use the Services, we will automatically collect data about your equipment, browsing actions, and patterns. We collect this personal data by using cookies, web beacons, pixel tags, server logs, and other similar technologies. We may also receive data about you if you visit other websites or applications that employ our cookies.
            </li>
            <li>
              <strong>(c) Information We Receive from Third Parties and Publicly Available Sources:</strong> We may receive personal data about you from various third parties such as analytics providers, financial institutions, advertising networks, search information providers, and other publicly available sources.
            </li>
          </ul>
        </div>
      </section>

      <!-- Section 4: How We Use Your Personal Data -->
      <section #howUseSection id="how-use" class="scroll-mt-24 pt-5 pb-5 border-t border-gray-100">
        <h2 class="text-2xl font-bold mb-4 text-black">4. HOW WE USE YOUR PERSONAL DATA</h2>
        <div class="space-y-4 text-sm leading-relaxed">
          <p>
            <strong>(a)</strong> We will only use your personal data when the law allows us to. Most commonly, we will use your personal data where we need to provide you with the Services or where we need to comply with a legal obligation.
          </p>
          <div>
            <p class="mb-2"><strong>(b)</strong> We use your personal data for the following purposes:</p>
            <ul class="list-disc ml-6 space-y-1">
              <li>(i) To carry out our obligations arising from the relationship with you, and/or to provide you with relevant information and Services.</li>
              <li>(ii) To market, promote or advertise the Services to you.</li>
              <li>(iii) To manage our relationship with you.</li>
              <li>(iv) To administer and protect our business and the Platform (including troubleshooting, data analysis, testing, system maintenance, support, reporting, and hosting of data).</li>
              <li>(v) To use data analytics to enhance security and make improvements to the Services, customer relationships, and your experiences.</li>
              <li>(vi) To enforce our Terms and other legal terms and policies.</li>
              <li>(vii) To comply with applicable legal requirements, such as government regulations and industry standards, contracts, and law enforcement requests.</li>
              <li>(viii) To respond to court orders, establish or exercise our legal rights, or defend ourselves against legal claims.</li>
              <li>(ix) To address your grievances, feedback, or inquiries.</li>
              <li>(x) To detect, respond and recover from cybersecurity incidents.</li>
              <li>(xi) To monitor trends so we can improve the Services, including through surveys or reviews.</li>
              <li>(xii) To detect and protect us against error, fraud, money laundering and other criminal activities.</li>
            </ul>
          </div>
          <p>
            <strong>(c)</strong> You agree and acknowledge that by using our Services and creating an account with us on the Platform, you authorise us, our associate partners, and affiliates to contact you via email, phone, or otherwise. This is to provide the Services to you and ensure that you are aware of all the features of the Services and for related purposes.
          </p>
          <div>
            <p class="mb-2">
              <strong>(d)</strong> You hereby agree and acknowledge that any and all personal data pertaining to you, may be shared by us for the purposes set out under this Policy to the following third parties:
            </p>
            <ul class="list-disc ml-6 space-y-1">
              <li>(i) Our group companies and affiliates.</li>
              <li>
                (ii) Third parties such as:
                <ul class="list-circle ml-6 mt-1 space-y-1">
                  <li>● our associate partners, and service providers that provide services for us or on our behalf, such as financial services and offerings, marketing, technical services, advisory services, and customer support services;</li>
                  <li>● analytics service providers and advertising networks that conduct web analytics for us to help us improve the Platform or the Services; and</li>
                  <li>● regulators and other public authorities, as required by law or regulation.</li>
                </ul>
              </li>
            </ul>
          </div>
          <p>
            <strong>(e)</strong> You agree and acknowledge that we may share data where we are required by law, any court, government agency, or authority to disclose such personal data. Such disclosures are made in good faith and belief that it is reasonably necessary to do so for enforcing this Policy or the Terms, or in order to comply with any applicable laws and regulations.
          </p>
        </div>
      </section>

      <!-- Section 5: Third-Party Services or Links -->
      <section #thirdPartySection id="third-party" class="scroll-mt-24 pt-5 pb-5 border-t border-gray-100">
        <h2 class="text-2xl font-bold mb-4 text-black">5. THIRD-PARTY SERVICES OR LINKS</h2>
        <div class="space-y-3 text-sm leading-relaxed">
          <p>
            <strong>(a)</strong> Our Services may, from time to time, contain third-party services or links to third-party services. Please note that the third-party services that may be accessible through our Services have their own privacy policies. Please review the privacy policies of such third parties to understand their data collection and usage practices.
          </p>
          <p>
            <strong>(b)</strong> Your relationship with these third parties and their services and tools is independent of your relationship with us. These third parties may allow you to permit or restrict the information that of information. It may be in your interest to individually restrict or enable such data collections.
          </p>
        </div>
      </section>

      <!-- Section 6: Cookies -->
      <section #cookiesSection id="cookies" class="scroll-mt-24 pt-5 pb-5 border-t border-gray-100">
        <h2 class="text-2xl font-bold mb-4 text-black">6. COOKIES</h2>
        <div class="space-y-3 text-sm leading-relaxed">
          <p>
            <strong>(a)</strong> Cookies are small files that a site or its service provider transfers to your device’s hard drive through your web browser (if you permit it to) that enable the websites or service providers’ systems to recognise your browser and capture and remember certain information.
          </p>
          <p>
            <strong>(b)</strong> We use cookies to help us distinguish you from other users of the Platform, understand and save your preferences for future visits, keep track of advertisements and compile aggregate data about site traffic and site interaction so that we can offer you a seamless user experience. We may contact third-party service providers to assist us in better understanding our site visitors. These service providers are not permitted to use the information collected on our behalf except to help us conduct and improve our business.
          </p>
          <p>
            <strong>(c)</strong> Additionally, you may encounter cookies or other similar devices on certain pages of the Platform that are placed by third parties. We do not control the use of cookies by third parties. If you send us personal correspondence, such as emails, or if other users or third parties send us correspondence about your activities or postings on the Platform, we may collect such information within a file specific to you.
          </p>
        </div>
      </section>

      <!-- Section 7: Your Rights in Relation to Your Personal Data -->
      <section #rightsSection id="rights" class="scroll-mt-24 pt-5 pb-5 border-t border-gray-100">
        <h2 class="text-2xl font-bold mb-4 text-black">7. YOUR RIGHTS IN RELATION TO YOUR PERSONAL DATA</h2>
        <div class="space-y-3 text-sm leading-relaxed">
          <p>
            <strong>(a)</strong> Under certain circumstances and subject to applicable laws and the Terms, you may have certain rights in respect of your personal data, such as the right to access, review and correct your personal data, or revoke or deny consent.
          </p>
          <p>
            <strong>(b)</strong> If you wish to exercise any of the rights set out above, please write an email to the grievance officer, whose details are mentioned in Section 11 of this Policy.
          </p>
        </div>
      </section>

      <!-- Section 8: Cross-Border Transfers of Personal Data -->
      <section #transfersSection id="transfers" class="scroll-mt-24 pt-5 pb-5 border-t border-gray-100">
        <h2 class="text-2xl font-bold mb-4 text-black">8. CROSS-BORDER TRANSFERS OF PERSONAL DATA</h2>
        <div class="space-y-3 text-sm leading-relaxed">
          <p>
            <strong>(a)</strong> We comply with applicable laws in respect of the storage and transfer of personal data. In the course of the Services, we may transfer your personal data to countries other than the one you are based in.
          </p>
          <p>
            <strong>(b)</strong> By submitting your information and personal data to us, you agree to the transfer, storage, and processing of such information and personal data in the manner described above.
          </p>
          <p>
            <strong>(c)</strong> You agree and understand that your personal data may be among the assets transferred to prospective buyers in the context of in case of an acquisition, merger or any other type of corporate or asset transition involving a change of ownership or control concerning us or our Services.
          </p>
        </div>
      </section>

      <!-- Section 9: Data Security -->
      <section #securitySection id="security" class="scroll-mt-24 pt-5 pb-5 border-t border-gray-100">
        <h2 class="text-2xl font-bold mb-4 text-black">9. DATA SECURITY</h2>
        <div class="space-y-3 text-sm leading-relaxed">
          <p>
            We implement adequate security measures to protect your personal data from unauthorised access, and such security measures are in compliance with the security practices and procedures prescribed under applicable laws.
          </p>
        </div>
      </section>

      <!-- Section 10: Data Retention -->
      <section #retentionSection id="retention" class="scroll-mt-24 pt-5 pb-5 border-t border-gray-100">
        <h2 class="text-2xl font-bold mb-4 text-black">10. DATA RETENTION</h2>
        <div class="space-y-3 text-sm leading-relaxed">
          <p>
            <strong>(a)</strong> You agree and acknowledge that your personal data will continue to be stored and retained by us for as long as necessary to fulfil our stated purpose(s) and for a reasonable period after the termination of your user account on the Platform or access to the Services to comply with our legal rights and obligations.
          </p>
          <p>
            <strong>(b)</strong> To determine the appropriate retention period for personal data, we consider the amount, nature, and sensitivity of the personal data, the potential risk of harm from unauthorised use or disclosure of your personal data, the purposes for which we process your personal data and whether we can achieve those purposes through other means, and the applicable legal requirements and limitation periods.
          </p>
          <p>
            <strong>(c)</strong> In some circumstances, we may aggregate your personal data (so that it can no longer be associated with you) for research or statistical purposes, in which case we may use this information indefinitely without further notice to you.
          </p>
        </div>
      </section>

      <!-- Section 11: Grievance Officer -->
      <section #grievanceSection id="grievance" class="scroll-mt-24 pt-5 pb-5 border-t border-gray-100">
        <h2 class="text-2xl font-bold mb-4 text-black">11. GRIEVANCE OFFICER</h2>
        <div class="space-y-3 text-sm leading-relaxed">
          <p>
            If you have any questions about this Policy, how we process or handle your personal data, or otherwise, you may reach out to us with your queries, grievances, feedback, and comments by contacting our grievance officer, whose details are provided below:
          </p>
          <div class="mt-4 p-4 bg-gray-50 rounded border border-gray-200">
            <div class="space-y-1">
              <p><strong>Name:</strong> [__]</p>
              <p><strong>Address:</strong> [__]</p>
              <p><strong>Email Address:</strong> [__]</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>

  <!-- Mobile Layout -->
  <div
    class="md:hidden w-full px-4 mt-2 inline-flex flex-col justify-start items-start gap-1"
  >
    <div class="self-stretch flex flex-col justify-start items-start">
      <div
        class="self-stretch pb-2 pt-2 inline-flex flex-col justify-start items-start gap-4"
      >
        <div
          class="self-stretch justify-start text-black text-xl font-bold leading-7"
        >
          Privacy Policy
        </div>
        <div class="text-xs font-semibold text-gray-500">
          Last updated: [__]
        </div>
        <div
          class="self-stretch justify-start text-black text-sm font-medium leading-tight"
        >
          At Tata Motors Limited (“Tata”, “us”, “our” and “we”), we are committed to protecting your personal data and respecting your privacy. This Privacy Policy (“Policy”) outlines our practices in relation to the collection, storage, usage, processing, and disclosure of personal data that you have consented to share with us when you access, use, or otherwise interact with our Platform or avail our Services.
        </div>
        <div
          class="self-stretch justify-start text-black text-sm font-medium leading-tight"
        >
          Please note that unless specifically defined in this Policy, capitalised terms shall have the same meaning ascribed to them in our Terms of Use, available at [insert link] (“Terms”). Please read this Policy in consonance with the Terms.
        </div>
      </div>

      <!-- Section 1 Mobile: Background and Key Information -->
      <div
        class="self-stretch py-5 border-b border-Input-field-Stroke flex flex-col justify-center items-start gap-3"
      >
        <div
          class="self-stretch inline-flex justify-between items-center cursor-pointer"
          (click)="toggleSection('background')"
        >
          <div class="flex-1 flex justify-start items-center gap-2">
            <div
              class="flex-1 justify-start text-black text-lg font-bold leading-normal"
            >
              1. Background and Key Information
            </div>
          </div>
          <div
            data-icon="Chevron-up"
            class="w-6 h-6 relative overflow-hidden transition-transform duration-200"
            [class.rotate-180]="!isExpanded('background')"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M6 9L11.2929 14.2929C11.6834 14.6834 12.3166 14.6834 12.7071 14.2929L18 9"
                stroke="black"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </div>
        <div
          class="self-stretch pl-2 flex flex-col justify-start items-start gap-3 transition-all duration-200"
          [class.hidden]="!isExpanded('background')"
        >
          <div>
            <h4 class="font-bold text-sm text-black mb-1">(a) How this Policy applies:</h4>
            <p class="text-black text-sm font-medium leading-tight">
              This Policy applies to individuals who access or use the Services (“you”). By accessing the Platform or using the Services, you confirm that you have read, accepted and consented to the terms of this Policy.
            </p>
          </div>
          <div>
            <h4 class="font-bold text-sm text-black mb-1">(b) Review and Updates:</h4>
            <p class="text-black text-sm font-medium leading-tight">
              We regularly review and update this Policy, and we request you to regularly review this Policy. It is important that the personal data we hold about you is accurate and current. Please keep us informed if your personal data changes during your relationship with us.
            </p>
          </div>
        </div>
      </div>

      <!-- Section 2 Mobile: Personal Data That We Collect -->
      <div
        class="self-stretch py-5 border-b border-Input-field-Stroke flex flex-col justify-center items-start gap-3"
      >
        <div
          class="self-stretch inline-flex justify-between items-center cursor-pointer"
          (click)="toggleSection('collect')"
        >
          <div class="flex-1 flex justify-start items-center gap-2">
            <div
              class="flex-1 justify-start text-black text-lg font-bold leading-normal"
            >
              2. Personal Data That We Collect
            </div>
          </div>
          <div
            data-icon="Chevron-up"
            class="w-6 h-6 relative overflow-hidden transition-transform duration-200"
            [class.rotate-180]="!isExpanded('collect')"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M6 9L11.2929 14.2929C11.6834 14.6834 12.3166 14.6834 12.7071 14.2929L18 9"
                stroke="black"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </div>
        <div
          class="self-stretch pl-2 flex flex-col justify-start items-start gap-3 transition-all duration-200"
          [class.hidden]="!isExpanded('collect')"
        >
          <p class="text-black text-sm font-medium leading-tight">
            <strong>(a)</strong> We collect different types of personal data about you, as may be applicable to you, depending on the utility our Services provide you with. This includes, but is not limited to:
          </p>
          <ul class="list-disc ml-6 space-y-2 text-black text-sm font-medium leading-tight">
            <li><strong>(i) Contact Data</strong>, such as your mailing address, email address, and mobile numbers.</li>
            <li><strong>(ii) Identity and Profile Data</strong>, such as your name, username or other similar identifiers, photographs, gender, designation, and details relating to your business operations.</li>
            <li><strong>(iii) Marketing and Communications Data</strong>, such as your office address, email address, information posted in service requests, offers, feedback, comments, pictures and discussions in our chat boxes, responses to surveys and polls, your preferences in receiving marketing communications from us and our third parties, and your communication preferences.</li>
            <li><strong>(iv) Technical Data</strong>, which includes your IP address, browser type, internet service provider, details of operating system, device ID, device type, location data, and other technology on the devices that you use to access the Platform.</li>
            <li><strong>(v) Transaction Data</strong>, which includes details of transactions that may occur through the Platform or in connection with the Services. For example, transaction data may include the Services you have sought or availed through the Platform or confirmations of such Services.</li>
            <li><strong>(vi) Financial Data</strong>, which includes your past credit history, income details, details of loans issued or otherwise applied for through the Platform, payments, and repayments thereof, bank account details, and bank account statements.</li>
            <li><strong>(vii) Usage Data</strong>, which includes information about how you use the Services, your activity on the Platform, booking history, frequency of engaging with the Platform, click rates, date and time stamps, page views, and user interests.</li>
          </ul>
          <p class="text-black text-sm font-medium leading-tight">
            <strong>(b)</strong> We also collect, use, and share aggregated data, such as statistical or demographic data, for our business purposes. Aggregated data could be derived from your personal data, but is not considered personal data under the law as it does not directly or indirectly reveal your identity. However, if we combine or connect aggregated data with your personal data so that it can directly or indirectly identify you, we treat the combined data as personal data, which will be used in accordance with this Policy.
          </p>
          <p class="text-black text-sm font-medium leading-tight">
            <strong>(c)</strong> Where we need to collect personal data by law, or under the Terms, and you fail to provide that data when requested, we may not be able to perform our obligations set out in the Terms or under applicable laws. In this case, we may have to limit your access to the Platform or cancel the Services you avail from us.
          </p>
        </div>
      </div>

      <!-- Section 3 Mobile: How We Collect Your Personal Data -->
      <div
        class="self-stretch py-5 border-b border-Input-field-Stroke flex flex-col justify-center items-start gap-3"
      >
        <div
          class="self-stretch inline-flex justify-between items-center cursor-pointer"
          (click)="toggleSection('how-collect')"
        >
          <div class="flex-1 flex justify-start items-center gap-2">
            <div
              class="flex-1 justify-start text-black text-lg font-bold leading-normal"
            >
              3. How We Collect Your Personal Data
            </div>
          </div>
          <div
            data-icon="Chevron-up"
            class="w-6 h-6 relative overflow-hidden transition-transform duration-200"
            [class.rotate-180]="!isExpanded('how-collect')"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M6 9L11.2929 14.2929C11.6834 14.6834 12.3166 14.6834 12.7071 14.2929L18 9"
                stroke="black"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </div>
        <div
          class="self-stretch pl-2 flex flex-col justify-start items-start gap-3 transition-all duration-200"
          [class.hidden]="!isExpanded('how-collect')"
        >
          <p class="text-black text-sm font-medium leading-tight">
            We use different methods to collect personal data from and about you, including through:
          </p>
          <ul class="list-disc ml-6 space-y-2 text-black text-sm font-medium leading-tight">
            <li><strong>(a) Direct Interactions:</strong> We collect data directly from you if and when you provide it to us through the Platform or any interaction with Tata.</li>
            <li><strong>(b) Automated Technologies or Interactions:</strong> Each time you visit the Platform or use the Services, we will automatically collect data about your equipment, browsing actions, and patterns. We collect this personal data by using cookies, web beacons, pixel tags, server logs, and other similar technologies. We may also receive data about you if you visit other websites or applications that employ our cookies.</li>
            <li><strong>(c) Information We Receive from Third Parties and Publicly Available Sources:</strong> We may receive personal data about you from various third parties such as analytics providers, financial institutions, advertising networks, search information providers, and other publicly available sources.</li>
          </ul>
        </div>
      </div>

      <!-- Section 4 Mobile: How We Use Your Personal Data -->
      <div
        class="self-stretch py-5 border-b border-Input-field-Stroke flex flex-col justify-center items-start gap-3"
      >
        <div
          class="self-stretch inline-flex justify-between items-center cursor-pointer"
          (click)="toggleSection('how-use')"
        >
          <div class="flex-1 flex justify-start items-center gap-2">
            <div
              class="flex-1 justify-start text-black text-lg font-bold leading-normal"
            >
              4. How We Use Your Personal Data
            </div>
          </div>
          <div
            data-icon="Chevron-up"
            class="w-6 h-6 relative overflow-hidden transition-transform duration-200"
            [class.rotate-180]="!isExpanded('how-use')"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M6 9L11.2929 14.2929C11.6834 14.6834 12.3166 14.6834 12.7071 14.2929L18 9"
                stroke="black"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </div>
        <div
          class="self-stretch pl-2 flex flex-col justify-start items-start gap-3 transition-all duration-200"
          [class.hidden]="!isExpanded('how-use')"
        >
          <p class="text-black text-sm font-medium leading-tight">
            <strong>(a)</strong> We will only use your personal data when the law allows us to. Most commonly, we will use your personal data where we need to provide you with the Services or where we need to comply with a legal obligation.
          </p>
          <div class="text-black text-sm font-medium leading-tight">
            <p class="mb-2"><strong>(b)</strong> We use your personal data for the following purposes:</p>
            <ul class="list-disc ml-6 space-y-1">
              <li>(i) To carry out our obligations arising from the relationship with you, and/or to provide you with relevant information and Services.</li>
              <li>(ii) To market, promote or advertise the Services to you.</li>
              <li>(iii) To manage our relationship with you.</li>
              <li>(iv) To administer and protect our business and the Platform (including troubleshooting, data analysis, testing, system maintenance, support, reporting, and hosting of data).</li>
              <li>(v) To use data analytics to enhance security and make improvements to the Services, customer relationships, and your experiences.</li>
              <li>(vi) To enforce our Terms and other legal terms and policies.</li>
              <li>(vii) To comply with applicable legal requirements, such as government regulations and industry standards, contracts, and law enforcement requests.</li>
              <li>(viii) To respond to court orders, establish or exercise our legal rights, or defend ourselves against legal claims.</li>
              <li>(ix) To address your grievances, feedback, or inquiries.</li>
              <li>(x) To detect, respond and recover from cybersecurity incidents.</li>
              <li>(xi) To monitor trends so we can improve the Services, including through surveys or reviews.</li>
              <li>(xii) To detect and protect us against error, fraud, money laundering and other criminal activities.</li>
            </ul>
          </div>
          <p class="text-black text-sm font-medium leading-tight">
            <strong>(c)</strong> You agree and acknowledge that by using our Services and creating an account with us on the Platform, you authorise us, our associate partners, and affiliates to contact you via email, phone, or otherwise. This is to provide the Services to you and ensure that you are aware of all the features of the Services and for related purposes.
          </p>
          <div class="text-black text-sm font-medium leading-tight">
            <p class="mb-2"><strong>(d)</strong> You hereby agree and acknowledge that any and all personal data pertaining to you, may be shared by us for the purposes set out under this Policy to the following third parties:</p>
            <ul class="list-disc ml-6 space-y-1">
              <li>(i) Our group companies and affiliates.</li>
              <li>
                (ii) Third parties such as:
                <ul class="list-circle ml-6 mt-1 space-y-1">
                  <li>● our associate partners, and service providers that provide services for us or on our behalf, such as financial services and offerings, marketing, technical services, advisory services, and customer support services;</li>
                  <li>● analytics service providers and advertising networks that conduct web analytics for us to help us improve the Platform or the Services; and</li>
                  <li>● regulators and other public authorities, as required by law or regulation.</li>
                </ul>
              </li>
            </ul>
          </div>
          <p class="text-black text-sm font-medium leading-tight">
            <strong>(e)</strong> You agree and acknowledge that we may share data where we are required by law, any court, government agency, or authority to disclose such personal data. Such disclosures are made in good faith and belief that it is reasonably necessary to do so for enforcing this Policy or the Terms, or in order to comply with any applicable laws and regulations.
          </p>
        </div>
      </div>

      <!-- Section 5 Mobile: Third-Party Services or Links -->
      <div
        class="self-stretch py-5 border-b border-Input-field-Stroke flex flex-col justify-center items-start gap-3"
      >
        <div
          class="self-stretch inline-flex justify-between items-center cursor-pointer"
          (click)="toggleSection('third-party')"
        >
          <div class="flex-1 flex justify-start items-center gap-2">
            <div
              class="flex-1 justify-start text-black text-lg font-bold leading-normal"
            >
              5. Third-Party Services or Links
            </div>
          </div>
          <div
            data-icon="Chevron-up"
            class="w-6 h-6 relative overflow-hidden transition-transform duration-200"
            [class.rotate-180]="!isExpanded('third-party')"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M6 9L11.2929 14.2929C11.6834 14.6834 12.3166 14.6834 12.7071 14.2929L18 9"
                stroke="black"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </div>
        <div
          class="self-stretch pl-2 flex flex-col justify-start items-start gap-3 transition-all duration-200"
          [class.hidden]="!isExpanded('third-party')"
        >
          <p class="text-black text-sm font-medium leading-tight">
            <strong>(a)</strong> Our Services may, from time to time, contain third-party services or links to third-party services. Please note that the third-party services that may be accessible through our Services have their own privacy policies. Please review the privacy policies of such third parties to understand their data collection and usage practices.
          </p>
          <p class="text-black text-sm font-medium leading-tight">
            <strong>(b)</strong> Your relationship with these third parties and their services and tools is independent of your relationship with us. These third parties may allow you to permit or restrict the information that of information. It may be in your interest to individually restrict or enable such data collections.
          </p>
        </div>
      </div>

      <!-- Section 6 Mobile: Cookies -->
      <div
        class="self-stretch py-5 border-b border-Input-field-Stroke flex flex-col justify-center items-start gap-3"
      >
        <div
          class="self-stretch inline-flex justify-between items-center cursor-pointer"
          (click)="toggleSection('cookies')"
        >
          <div class="flex-1 flex justify-start items-center gap-2">
            <div
              class="flex-1 justify-start text-black text-lg font-bold leading-normal"
            >
              6. Cookies
            </div>
          </div>
          <div
            data-icon="Chevron-up"
            class="w-6 h-6 relative overflow-hidden transition-transform duration-200"
            [class.rotate-180]="!isExpanded('cookies')"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M6 9L11.2929 14.2929C11.6834 14.6834 12.3166 14.6834 12.7071 14.2929L18 9"
                stroke="black"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </div>
        <div
          class="self-stretch pl-2 flex flex-col justify-start items-start gap-3 transition-all duration-200"
          [class.hidden]="!isExpanded('cookies')"
        >
          <p class="text-black text-sm font-medium leading-tight">
            <strong>(a)</strong> Cookies are small files that a site or its service provider transfers to your device’s hard drive through your web browser (if you permit it to) that enable the websites or service providers’ systems to recognise your browser and capture and remember certain information.
          </p>
          <p class="text-black text-sm font-medium leading-tight">
            <strong>(b)</strong> We use cookies to help us distinguish you from other users of the Platform, understand and save your preferences for future visits, keep track of advertisements and compile aggregate data about site traffic and site interaction so that we can offer you a seamless user experience. We may contact third-party service providers to assist us in better understanding our site visitors. These service providers are not permitted to use the information collected on our behalf except to help us conduct and improve our business.
          </p>
          <p class="text-black text-sm font-medium leading-tight">
            <strong>(c)</strong> Additionally, you may encounter cookies or other similar devices on certain pages of the Platform that are placed by third parties. We do not control the use of cookies by third parties. If you send us personal correspondence, such as emails, or if other users or third parties send us correspondence about your activities or postings on the Platform, we may collect such information within a file specific to you.
          </p>
        </div>
      </div>

      <!-- Section 7 Mobile: Your Rights in Relation to Your Personal Data -->
      <div
        class="self-stretch py-5 border-b border-Input-field-Stroke flex flex-col justify-center items-start gap-3"
      >
        <div
          class="self-stretch inline-flex justify-between items-center cursor-pointer"
          (click)="toggleSection('rights')"
        >
          <div class="flex-1 flex justify-start items-center gap-2">
            <div
              class="flex-1 justify-start text-black text-lg font-bold leading-normal"
            >
              7. Your Rights in Relation to Your Personal Data
            </div>
          </div>
          <div
            data-icon="Chevron-up"
            class="w-6 h-6 relative overflow-hidden transition-transform duration-200"
            [class.rotate-180]="!isExpanded('rights')"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M6 9L11.2929 14.2929C11.6834 14.6834 12.3166 14.6834 12.7071 14.2929L18 9"
                stroke="black"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </div>
        <div
          class="self-stretch pl-2 flex flex-col justify-start items-start gap-3 transition-all duration-200"
          [class.hidden]="!isExpanded('rights')"
        >
          <p class="text-black text-sm font-medium leading-tight">
            <strong>(a)</strong> Under certain circumstances and subject to applicable laws and the Terms, you may have certain rights in respect of your personal data, such as the right to access, review and correct your personal data, or revoke or deny consent.
          </p>
          <p class="text-black text-sm font-medium leading-tight">
            <strong>(b)</strong> If you wish to exercise any of the rights set out above, please write an email to the grievance officer, whose details are mentioned in Section 11 of this Policy.
          </p>
        </div>
      </div>

      <!-- Section 8 Mobile: Cross-Border Transfers of Personal Data -->
      <div
        class="self-stretch py-5 border-b border-Input-field-Stroke flex flex-col justify-center items-start gap-3"
      >
        <div
          class="self-stretch inline-flex justify-between items-center cursor-pointer"
          (click)="toggleSection('transfers')"
        >
          <div class="flex-1 flex justify-start items-center gap-2">
            <div
              class="flex-1 justify-start text-black text-lg font-bold leading-normal"
            >
              8. Cross-Border Transfers of Personal Data
            </div>
          </div>
          <div
            data-icon="Chevron-up"
            class="w-6 h-6 relative overflow-hidden transition-transform duration-200"
            [class.rotate-180]="!isExpanded('transfers')"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M6 9L11.2929 14.2929C11.6834 14.6834 12.3166 14.6834 12.7071 14.2929L18 9"
                stroke="black"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </div>
        <div
          class="self-stretch pl-2 flex flex-col justify-start items-start gap-3 transition-all duration-200"
          [class.hidden]="!isExpanded('transfers')"
        >
          <p class="text-black text-sm font-medium leading-tight">
            <strong>(a)</strong> We comply with applicable laws in respect of the storage and transfer of personal data. In the course of the Services, we may transfer your personal data to countries other than the one you are based in.
          </p>
          <p class="text-black text-sm font-medium leading-tight">
            <strong>(b)</strong> By submitting your information and personal data to us, you agree to the transfer, storage, and processing of such information and personal data in the manner described above.
          </p>
          <p class="text-black text-sm font-medium leading-tight">
            <strong>(c)</strong> You agree and understand that your personal data may be among the assets transferred to prospective buyers in the context of in case of an acquisition, merger or any other type of corporate or asset transition involving a change of ownership or control concerning us or our Services.
          </p>
        </div>
      </div>

      <!-- Section 9 Mobile: Data Security -->
      <div
        class="self-stretch py-5 border-b border-Input-field-Stroke flex flex-col justify-center items-start gap-3"
      >
        <div
          class="self-stretch inline-flex justify-between items-center cursor-pointer"
          (click)="toggleSection('security')"
        >
          <div class="flex-1 flex justify-start items-center gap-2">
            <div
              class="flex-1 justify-start text-black text-lg font-bold leading-normal"
            >
              9. Data Security
            </div>
          </div>
          <div
            data-icon="Chevron-up"
            class="w-6 h-6 relative overflow-hidden transition-transform duration-200"
            [class.rotate-180]="!isExpanded('security')"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M6 9L11.2929 14.2929C11.6834 14.6834 12.3166 14.6834 12.7071 14.2929L18 9"
                stroke="black"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </div>
        <div
          class="self-stretch pl-2 flex flex-col justify-start items-start gap-3 transition-all duration-200"
          [class.hidden]="!isExpanded('security')"
        >
          <p class="text-black text-sm font-medium leading-tight">
            We implement adequate security measures to protect your personal data from unauthorised access, and such security measures are in compliance with the security practices and procedures prescribed under applicable laws.
          </p>
        </div>
      </div>

      <!-- Section 10 Mobile: Data Retention -->
      <div
        class="self-stretch py-5 border-b border-Input-field-Stroke flex flex-col justify-center items-start gap-3"
      >
        <div
          class="self-stretch inline-flex justify-between items-center cursor-pointer"
          (click)="toggleSection('retention')"
        >
          <div class="flex-1 flex justify-start items-center gap-2">
            <div
              class="flex-1 justify-start text-black text-lg font-bold leading-normal"
            >
              10. Data Retention
            </div>
          </div>
          <div
            data-icon="Chevron-up"
            class="w-6 h-6 relative overflow-hidden transition-transform duration-200"
            [class.rotate-180]="!isExpanded('retention')"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M6 9L11.2929 14.2929C11.6834 14.6834 12.3166 14.6834 12.7071 14.2929L18 9"
                stroke="black"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </div>
        <div
          class="self-stretch pl-2 flex flex-col justify-start items-start gap-3 transition-all duration-200"
          [class.hidden]="!isExpanded('retention')"
        >
          <p class="text-black text-sm font-medium leading-tight">
            <strong>(a)</strong> You agree and acknowledge that your personal data will continue to be stored and retained by us for as long as necessary to fulfil our stated purpose(s) and for a reasonable period after the termination of your user account on the Platform or access to the Services to comply with our legal rights and obligations.
          </p>
          <p class="text-black text-sm font-medium leading-tight">
            <strong>(b)</strong> To determine the appropriate retention period for personal data, we consider the amount, nature, and sensitivity of the personal data, the potential risk of harm from unauthorised use or disclosure of your personal data, the purposes for which we process your personal data and whether we can achieve those purposes through other means, and the applicable legal requirements and limitation periods.
          </p>
          <p class="text-black text-sm font-medium leading-tight">
            <strong>(c)</strong> In some circumstances, we may aggregate your personal data (so that it can no longer be associated with you) for research or statistical purposes, in which case we may use this information indefinitely without further notice to you.
          </p>
        </div>
      </div>

      <!-- Section 11 Mobile: Grievance Officer -->
      <div
        class="self-stretch py-5 border-b border-Input-field-Stroke flex flex-col justify-center items-start gap-3"
      >
        <div
          class="self-stretch inline-flex justify-between items-center cursor-pointer"
          (click)="toggleSection('grievance')"
        >
          <div class="flex-1 flex justify-start items-center gap-2">
            <div
              class="flex-1 justify-start text-black text-lg font-bold leading-normal"
            >
              11. Grievance Officer
            </div>
          </div>
          <div
            data-icon="Chevron-up"
            class="w-6 h-6 relative overflow-hidden transition-transform duration-200"
            [class.rotate-180]="!isExpanded('grievance')"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M6 9L11.2929 14.2929C11.6834 14.6834 12.3166 14.6834 12.7071 14.2929L18 9"
                stroke="black"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </div>
        <div
          class="self-stretch pl-2 flex flex-col justify-start items-start gap-3 transition-all duration-200"
          [class.hidden]="!isExpanded('grievance')"
        >
          <p class="text-black text-sm font-medium leading-tight">
            If you have any questions about this Policy, how we process or handle your personal data, or otherwise, you may reach out to us with your queries, grievances, feedback, and comments by contacting our grievance officer, whose details are provided below:
          </p>
          <div class="mt-2 p-3 bg-gray-50 rounded border border-gray-200 w-full text-black text-sm font-medium leading-tight space-y-1">
            <p><strong>Name:</strong> [__]</p>
            <p><strong>Address:</strong> [__]</p>
            <p><strong>Email Address:</strong> [__]</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
